/**
 * Десериализатор Query Builder
 * Преобразует API структуру в UI дерево для редактирования
 */

import {
  isFilterCriterion,
  isFilterGroup,
  ZFilterGroup,
  ZFilterItem,
} from "../types/ZFilterApiTypes";
import { ZGroupNode, ZQueryBuilderNode } from "../types/ZQueryBuilderTypes";
import { generateNodeId } from "./treeUtils";

/**
 * Преобразование API элемента в UI узел
 * @param item - элемент API структуры
 * @returns UI узел
 */
const deserializeItem = (item: ZFilterItem): ZQueryBuilderNode => {
  if (isFilterGroup(item)) {
    // Группа: рекурсивно десериализуем дочерние элементы
    const group: ZGroupNode = {
      type: "group" as const,
      id: generateNodeId(),
      op: item.op,
      items: item.items.map((child) => deserializeItem(child)),
    };

    return group;
  }
  if (isFilterCriterion(item)) {
    // Критерий: преобразуем в UI формат
    return {
      type: "criterion" as const,
      id: generateNodeId(),
      fieldMeta: item.fieldMeta,
      valueType: item.type,
      operator: item.operator,
      value: item.value ?? null,
    };
  }

  // Fallback: создаем пустой критерий
  return {
    type: "criterion" as const,
    id: generateNodeId(),
    fieldMeta: null,
    valueType: null,
    operator: null,
    value: null,
  };
};

/**
 * Десериализация FilterGroup в корневую группу UI
 * @param filterGroup - API структура фильтра
 * @returns корневая группа UI дерева
 */
export const deserializeFilterTree = (
  filterGroup: ZFilterGroup,
): ZGroupNode => ({
  type: "group" as const,
  id: generateNodeId(),
  op: filterGroup.op,
  items: filterGroup.items.map((item) => deserializeItem(item)),
});
